module.exports = __webpack_public_path__ + "img/Online-icon.7dcfc430.svg";